"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _ImmutableAPI = require("crm_data/api/ImmutableAPI");

var API_URL = 'filemanager/api/v2/files/multiple';
var AttachmentsAPI = {
  fetch: function fetch(attachmentIds) {
    return (0, _ImmutableAPI.get)(API_URL, {
      id: attachmentIds.toJS()
    }, function (attachments) {
      return (0, _immutable.fromJS)(attachments).reduce(function (keyedAttachments, attachment) {
        if (!attachment) {
          return keyedAttachments;
        }

        return keyedAttachments.set("" + attachment.get('id'), attachment);
      }, (0, _immutable.Map)());
    });
  }
};
var _default = AttachmentsAPI;
exports.default = _default;
module.exports = exports.default;